//乌尔都语
export default { 
 common: { 
 unit: 'یو ایس ڈی ٹی', 
 day: 'دن', 
 week: 'ہفتہ', 
 save: 'محفوظ کریں', 
 submit: 'جما کریں', 
 confirmtitle: 'آپریشن کا عمل انجام دیں', 
 confirm: 'تصدیق کریں', 
 reset: 'ری سیٹ کریں', 
 refresh: 'تازہ کریں', 
 copy: 'کاپی کریں', 
 copysuccessful: 'کاپی کامیاب', 
 modify: 'تبدیل کریں', 
 binding: 'بند کریں', 
 finished: 'پورا ہو گیا', 
 canceled: 'منسوخ ہو گیا', 
 cancel: 'منسوخ کریں', 
 all: 'تمام', 
 back: 'واپس جائیں', 
 loading: 'لوڈنگ میں...', 
 nomore: 'تمام ریکارڈ', 
 errortxt: 'لوڈ کرنے میں ناکامی', 
 loosing: 'ریليز کریں تازہ کریں...', 
 pulling: 'پل کریں تازہ کریں...', 
 nodata: 'ابھی کوئی ریکارڈ نہیں', 
 buy: 'خریدیں', 
 buyup: 'اوپر کی طرف خریدیں', 
 buydown: 'نیچے کی طرف خریدیں', 
 sell: 'فروخت کریں', 
 forserver: 'کسٹمر سروس سے رابطہ کریں', 
 total: 'کل', 
 status1: 'جائزہ لینے کے لئے ', 
 status2: 'مکمل ', 
 status3: 'نامنگھول', 
 paytype1: 'TRC20', 
 paytype2: 'ERC20', 
 paytype3: 'ایلکٹرانک ٹرانسفر', 
 }, 
 footer: { 
 home: 'ہوم پیج', 
 market: 'حالات', 
 exchange: 'کرنسیوں کا تبادلہ', 
 options: 'آپشنز', 
 assets: 'اثاثہ', 
 change: 'ٹرانسفر کریں', 
 recharge: 'جولڈ کریں', 
 withdrawal: 'واپس نکالیں' 
 }, 
 home: { 
 menu1: 'آپشن ٹریڈنگ', 
 menu1desc: 'BTC/USDT وغیرہ کی حمایت کریں', 
 menu2: 'فوری ریچارج', 
 menu3: 'واپس نکالیں', 
 menu4: 'آن لائن کسٹمر سروس', 
 menu5: 'فوری تبدیل', 
 menu6: 'بھاری قرض', 
 menu7: 'مکھیز کھدائی', 
 menu8: 'پناہ', 
 menu9: 'اکاؤنٹ ٹرانسفر کریں', 
 ranktitle: 'فروغ کا فہرست', 
 name: 'نام', 
 price: 'تازہ قیمت', 
 risefall: 'اضافہ/کمی', 
 }, 
 register: { 
 register: 'رجسٹر کریں', 
 login: 'لاگ ان کریں', 
 email: 'ای میل', 
 phone: 'فون نمبر', 
 accountplaceholder: 'اکاؤنٹ داخل کریں', 
 emailplaceholder: 'ای میل داخل کریں', 
 phoneplaceholder: 'فون داخل کریں', 
 pwdplaceholder: 'پاس ورڈ داخل کریں', 
 pwdplaceholder1: 'پاس ورڈ 6-20 حروف کے کسی بھی حروف تہجی اور عددی ہونا چاہئے', 
 agepwdplaceholder: 'پاس ورڈ دوبارہ داخل کریں', 
 agepwdplaceholder1: 'دونوں پاس ورڈیں مختلف ہیں', 
 invitecodeplaceholder: 'دعوت نامہ داخل کریں', 
 remember: 'پاس ورڈ یاد رکھیں', 
 fotget: 'پاس ورڈ بھول گئے' 
 }, 
 market:{ 
 title: 'حالات', 
 all: 'تمام' 
 }, 
 member:{ 
 reputation:'سمعت کا سکور', 
 identity_authentication:'شناخت کی تصدیق', 
 under_review:'جائزہ لینے کے لئے', 
 certified:'تصدیق شدہ', 
 awaiting_certification:'تصدیق کے انتظار میں', 
 binding_withdrawal_address: 'واپس نکالیں ایڈریس باندھیں', 
 currently_selected_currency:'فی الحال منتخب کرنسی', 
 withdrawal_address:'واپس نکالیں ایڈریس', 
 sharing_link:'میرا اشتراک لینک', 
 my_promotion_code:'میرا پروموشن کوڈ', 
 promotion_code:'پروموشن کوڈ', 
 system_message:'سسٹم کا پیغام', 
 night_mode:'رات کا موڈ', 
 security_center:'سیکیورٹی سینٹر', 
 seted: 'سیٹ شدہ', 
 noset: 'سیٹ نہیں کیا گیا', 
 login_password:'لاگ ان کا پاس ورڈ', 
 transaction_password:'کاش آؤٹ کا پاس ورڈ', 
 app_download:'ایپ ڈاؤن لوڈ کریں', 
 log_out:'لاگ آؤٹ کریں', 
 aboutus: 'ویب سائٹ کا تعارف' 
 }, 
 identity:{ 
 title: 'شناخت کی تصدیق', 
 name: 'نام', 
 nameplaceholder: 'اصلی نام داخل کریں', 
 uploader: ' شناخت کارڈ کی تصویر اپ لوڈ کریں', 
 tip1: 'شناخت کارڈ کا سامنے کا حصہ اپ لوڈ کریں', 
 tip2: 'شناخت کارڈ کا پیچھے کا حصہ اپ لوڈ کریں' 
 }, 
 address: { 
 title: 'واپس نکالیں ایڈریس باندھیں', 
 bType: 'فی الحال منتخب کرنسی', 
 address: 'واپس نکالیں ایڈریس', 
 addressplaceholder:'واپس نکالیں ایڈریس داخل کریں', 
 }, 
 security:{ 
 title: 'سیکیورٹی سینٹر', 
 modifypwd: 'لاگ ان کا پاس ورڈ', 
 resetlegalpwd: 'کاش آؤٹ کا پاس ورڈ', 
 loginpwd: 'نیا لاگ ان کا پاس ورڈ', 
 pwdage: 'پاس ورڈ کی تصدیق کریں', 
 loginpwdplaceholder:'موجودہ لاگ ان کا پاس ورڈ داخل کریں', 
 loginnewpwdplaceholder: 'نیا لاگ ان کا پاس ورڈ داخل کریں', 
 moneypwd: 'کاش آؤٹ کا پاس ورڈ داخل کریں', 
 pwdageplaceholder:'پاس ورڈ دوبارہ داخل کریں' 
 }, 
 trade:{ 
 title: 'کرنسیوں کا تبادلہ', 
 price: 'قیمت', 
 num: 'تعداد', 
 entrust: 'موجودہ تفویض', 
 clinch: 'حقیقی معاہدے', 
 used: 'دستیاب', 
 buyed: 'خرید سکتے ہیں', 
 amount: 'مقدار', 
 limitprice: 'محدود قیمت', 
 marketprice: 'بازاری قیمت', 
 forprice: 'فی الحال بہترین قیمت سے تجارت کریں', 
 errorMoney: 'دستیاب بیلنس ناکافی ہے', 
 priceerror: 'تفویض قیمت داخل کریں', 
 numerror: 'تفویض تعداد داخل کریں', 
 moneyerror: 'تفویض رقم داخل کریں', 
 }, 
 assets:{ 
 allconvert:'کل اثاثہ جوڑیں', 
 usenum: 'دستیاب', 
 freeze: 'جمد', 
 convert: 'جوڑیں', 
 tab1:'اثاثہ', 
 tab11: 'کل اثاثہ جوڑیں', 
 tab12: 'آپشن جوڑیں', 
 tab13: 'فنڈز جوڑیں', 
 tab14: 'کوانٹیٹیو جوڑیں', 
 tab2:'آپشن', 
 tab21: 'آپشن اکاؤنٹ', 
 tab3:'فنڈز', 
 tab31:'فنڈز اکاؤنٹ', 
 tab4:'کوانٹیٹیو', 
 tab41:'کوانٹیٹیو اکاؤنٹ', 
 tbhead1: 'مالی ریکارڈ', 
 tbhead2: 'واپس نکالیں ریکارڈ', 
 tbhead3: 'جولڈ ریکارڈ', 
 tbhead4: 'ٹرانسفر ریکارڈ', 
 rcdnum: 'تعداد', 
 rcd: 'ریکارڈ', 
 rcdtime: 'وقت' , 
 rcdstatus: 'حالت', 
 rcddesc: 'نوٹ', 
 rcdaddress: 'جولڈ ایڈریس' 
 }, 
 change:{ 
 title: 'ٹرانسفر کریں', 
 from: 'سے {name}', 
 to: 'پر {name}', 
 frmtitle: 'ٹرانسفر کی تعداد', 
 inputplaceholder: 'ٹرانسفر کی تعداد داخل کریں', 
 btntxt:'ٹرانسفر کریں' 
 }, 
 recharge:{ 
 title: 'جولڈ کریں', 
 bType: 'فی الحال منتخب کرنسی', 
 address: 'جولڈ ایڈریس', 
 token: 'ادائیگی کا ثبوت', 
 tokenplaceholder: 'ادائیگی کا ثبوت اپ لوڈ کریں', 
 num: 'جولڈ کی تعداد', 
 numplaceholder: 'تعداد داخل کریں', 
 btn: 'جائزہ لینے کے لئے جمع کریں', 
 bankname: 'بینک کا نام', 
 bankno: 'بینک کا نمبر', 
 accountname: 'وصول کنندہ اکاؤنٹ کا نام', 
 bankaddress: 'بینک کا پتہ', 
 bankcode: 'بینک کی ریمٹ کوڈ', 
 companyaddress: 'کمپنی کا پتہ' 
 }, 
 withdrawal:{ 
 title:'واپس نکالیں', 
 frmtitle1: 'تعداد', 
 frmplaceholder1: 'واپس نکالیں کی تعداد {min} - {max} کے درمیان', 
 frmtitle2: 'کاش آؤٹ کا پاس ورڈ', 
 frmplaceholder2: 'کاش آؤٹ کا پاس ورڈ داخل کریں', 
 getnum: 'حاصل ہونے والی تعداد', 
 fee:'فیس', 
 btn: 'واپس نکالیں' 
 }, 
 exchangeb:{ 
 title: 'تبادلہ کریں', 
 account: 'اکاؤنٹ', 
 btn: 'تبادلہ کریں', 
 numerror: 'تبادلہ کرنے کی تعداد داخل کریں' 
 }, 
 option:{ 
 title: 'آپشن', 
 typetitle: 'سیکنڈ کنٹریکٹ', 
 listtitle: 'ہولڈنگ', 
 kline: 'K لائن', 
 high: 'اعلی', 
 low: 'نیچے', 
 nums: '24 گھنٹے کی تعداد', 
 time: 'وقت', 

 transaction: 'ٹرانزیکشن کا طریقہ', 
 quantity: 'کھولنے کی تعداد', 
 quantityerror: 'کھولنے کی تعداد داخل کریں', 
 times: 'کھولنے کا وقت', 
 times1: 'تصفیہ کا وقت',
 account: 'اکاؤنٹ بیلنس', 
 buyup:'اوپر کی طرف خریدیں', 
 buydown: 'نیچے کی طرف خریدیں', 
 tab1: 'ہولڈنگ لسٹ', 
 tab2: 'آرڈر ریکارڈ', 
 num: 'تعداد', 
 price1: 'خریداری کی قیمت', 
 price2: 'فروخت کی قیمت', 
 profitandloss: 'متوقع منافع اور نقصان', 
 profitandloss1: 'منافع اور نقصان', 
 countdown: 'કાઉન્ટડાઉન', 
 waitfinish: 'حساب لگانے کے لئے انتظار کریں', 
 finishing: 'حساب لگانے میں...', 
 finished: 'حساب لگایا گیا', 
 order_price: 'موجودہ قیمت', 
 order_cycle: 'دور', 
 order_type: 'قسم', 
 order_money: 'رقم', 
 order_time: 'پٹھان', 
 order_get: 'منافع', 
 order_btn: 'ابھی آرڈر دیں' 
 }, 
 tradelst:{ 
 title: 'میری تفویض', 
 tab1: 'تفویض', 
 tab2: 'معاہدے مکمل', 
 tab3: 'منسوخ شدہ', 
 usdtnum: '' 
 }, 
 loans:{ 
 title: 'بھاری قرض', 
 order_tab: 'قرض کے آرڈر', 
 pro_tab: 'قرض کی مصنوعات', 
 
 Institution:'قرض دینے والی ادارہ', 
 Amount: 'رقم', 
 DailyInterest:'روزانہ سود', 
 RepaymentPeriod:'ادائیگی کا دور', 
 Application: 'قرض کی درخواست کریں', 
 orderno: 'آرڈر نمبر', 
 AllInterest: 'کل سود', 
 RepaymentDate:'ادائیگی کی تاریخ', 
 RepaymentMethod: 'ادائیگی کا طریقہ', 
 Onetime: 'ایک بار', 
 Expected_loan_amount:'مطلوبہ قرض کی رقم', 
 Expected_loan_amounterror:'قرض کی رقم {min} - {max} کے درمیان ہونی چاہئے', 
 imgplaceholdr: 'کریڈٹ لیندنگ (براہ کرم تصویر کو واضح طور پر دیکھیں)', 
 icon1: 'سند کا سامنے کا حصہ اپ لوڈ کریں', 
 icon2: 'سند کا پیچھے کا حصہ اپ لوڈ کریں', 
 icon3: 'ہاتھ میں سند اپ لوڈ کریں', 
 status1: 'درخواست میں', 
 status2: 'درخواست منظور', 
 status3: 'درخواست ناکام', 
 }, 
 lockming:{ 
 title: 'مکھیز کھدائی', 
 order_tab: 'کان کی آرڈر', 
 pro_tab: 'کان کی مارکیٹ', 
 locknum: 'کم سے کم مکھیز کی تعداد', 
 getforday: 'ریٹرن / دن', 
 days: 'دن', 
 estimation: 'اندازہ لگایا گیا منافع', 
 real: 'حاصل ہوا منافع', 
 balance: 'والٹ بیلنس', 
 nums: 'مکھیز کی تعداد', 
 tolockming: 'مکھیز کریں', 
 stime: 'شروع ہونے کا وقت', 
 etime: 'ختم ہونے کا وقت', 
 }, 
 transfer:{ 
 title: 'اکاؤنٹ ٹرانسفر کریں', 
 searchtxt: 'مقابلہ اکاؤنٹ داخل کریں', 
 ReceivingAccount: 'وصول کنندہ اکاؤنٹ کی معلومات', 
 toaccount: 'اکاؤنٹ', 
 confirmtxt: 'براہ کرم وصول کنندہ اکاؤنٹ کی تصدیق کریں', 
 confirmedtxt: 'وصول کنندہ اکاؤنٹ کی تصدیق ہو چکی ہے', 
 numtxt: 'ٹرانسفر کی تعداد', 
 numerror: 'ٹرانسفر کی تعداد داخل کریں', 
 fee: 'اندرونی ٹرانسفر کے لئے کوئی فیس نہیں', 
 ArrivalTime: 'پہنچنے کا وقت', 
 Immediately: 'فوری طور پر پہنچ جائے گا', 
 realnum: 'اصل حاصل ہونے والی تعداد', 
 btn: 'ٹرانسفر کی تصدیق کریں', 
 
 transfering: 'ٹرانسفر ہو رہا ہے', 
 orderNo: 'آرڈر نمبر', 
 stime: 'ٹرانسفر کا وقت', 
 etime: 'پہنچنے کا وقت', 
 receiving: 'وصول کنندہ اکاؤنٹ', 
 type: 'کرنسی', 
 num: 'ٹرانسفر کی تعداد', 
 arrivalnum: 'دریافت ہونے والی تعداد' 
 }, 
 staking:{ 
 title: 'پناہ', 
 record: 'ریکارڈ', 
 getforyear: 'سالانہ منافع کا حوالہ', 
 time: 'سرمایہ کاری کی مدت', 
 snum: 'کم سے کم سرمایہ کاری کی تعداد', 
 snumerror: 'کم سے کم سرمایہ کاری کی تعداد داخل کریں', 
 snumerror1: 'کم سے کم سرمایہ کاری کی تعداد {num} سے کم نہیں ہونی چاہئے', 
 join: 'فوری طور پر حصہ لیں', 
 opentime: 'پٹھان کا وقت', 
 money: 'سرمایہ کاری کی رقم', 
 days: 'دور', 
 recordget: 'سالانہ منافع', 
 gets: 'منافع', 
 stime: 'شروع ہونے کی تاریخ', 
 etiem: 'ختم ہونے کی تاریخ', 
 redeemStaking: 'منسوخ کریں', 
 status0: 'پناہ میں', 
 status1: 'آرڈر ختم', 
 status2: 'آرڈر کی واپسی', 
 }, 
 bank:{ 
 title: 'بینک کا کارڈ باندھیں', 
 bankName: 'بینک کا نام', 
 bankNameError: 'بینک کا نام داخل کریں', 
 usrName: 'کارڈ ہولڈر', 
 usrNameError: 'کارڈ ہولڈر کا نام داخل کریں', 
 cardCode: 'بینک کا کارڈ نمبر', 
 cardCodeError: 'بینک کا کارڈ نمبر داخل کریں', 
 towallet: 'والٹ میں جولڈ کریں', 
 tobank: 'بینک کا کارڈ میں جولڈ کریں', 
 sendcode: 'کوڈ بھیجیں', 
 sended: '{num} سیکنڈ کے بعد دوبارہ بھیجیں', 
 verify_code: 'ای میل کا کوڈ داخل کریں' 
 },
 other:{
        welcome: 'ہیلو، {name} میں خوش آمدید',
    homeaboutustitle: 'عالمی سطح پر معروف ایک اسٹاپ ڈیجیٹل اثاثوں کا تبادلہ پلیٹ فارم',
    homeaboutustitle1: 'سیکورٹی کی ضمانت',
    homeaboutusdesc1: 'صارفین کے محفوظ اور مؤثر لین دین کو یقینی بنانے کے لیے متعدد اعلیٰ سطحی سیکورٹی اداروں کے ساتھ تعاون',
    homeaboutustitle2: '24 گھنٹے کسٹمر سروس',
    homeaboutusdesc2: '24 گھنٹے آن لائن کسٹمر سروس، آپ کی ضروریات کے فوری جواب دینے کے لیے تیار',
    homeaboutustitle3: 'عالمی کوریج',
    homeaboutusdesc3: 'بین الاقوامی کمیونٹی، 205 ممالک/علاقوں کو کور کرتا ہے، 11 زبانوں کی سپورٹ، 19 قومی/علاقائی کمیونٹیز، 50 لاکھ رجسٹرڈ صارفین',
    totrade: 'ٹریڈنگ شروع کریں',
    toregister: 'ڈیجیٹل کرنسی کے سفر کا آغاز کریں',
    yingli: 'آج کا منافع',
    kuisun: 'آج کا نقصان',
    agree: 'میں نے پڑھ لیا ہے اور قبول کرتا ہوں',
    useragreement: 'صارف معاہدہ',
    account: 'اکاؤنٹ',
    pwd: 'پاسورڈ',
    toregister1: 'ابھی تک رجسٹر نہیں کیا؟',
    loginbtn: 'لاگ ان کریں',
    registerbtn: 'فوری رجسٹر کریں',
    tologin: 'پہلے سے اکاؤنٹ ہے؟ رجسٹریشن پر جائیں',
    allrevenue: 'کل آمدنی',
    stakingcount: 'سٹیکنگ آرڈر',
    stakingamount: 'سٹیکنگ رقم',
    todayincome: 'آج کا تخمینہ'

 }
}
